module.exports = __webpack_public_path__ + "static/media/Jonathan_Laluces_Master_Resume.fbe46aa4.pdf";